<template lang="pug">
v-card
  v-row.pt-2.px-3(no-gutters, justify="end")
    v-btn(icon, @click="$store.commit('setPayDialog', false)")
      v-icon mdi-close
  v-card-text
    v-row(v-if="select === null", align="stretch")
      v-col(md="12")
        v-card.d-flex.flex-column(style="height: 100%", color="#f8f9fc")
          v-card-title.text-center.justify-center.py-6
            div
              h3 Sponsor licence service - £540
              h5 (£450* + 20% VAT)
          v-card-text(style="flex-grow: 1")
            .d-flex.flex-column.justify-center.align-center(
              style="height: 100%"
            )
              ul.accept-list.body-1(style="width: 490px")
                li List of all supporting documents
                li.mt-2 Onboarding of a candidate
                li.mt-2 Case review by a qualified immigration advisor
                li.mt-2 Cover letter to support the application
                li.mt-2 Creation of an online Home Office application
              ul.decline-list.body-1(style="width: 490px")
                li.mt-2 Representation and communication with the Home Office
              span.mt-4(style="width: 490px")
                | *The price does not include Home Office
                | administrative and application fees
              v-checkbox(v-model="acceptTerms", style="width: 490px")
                template(v-slot:label)
                  div
                    div
                      span Please confirm that you agree with
                      a.ml-1(
                        target="_blank",
                        href="https://drive.google.com/file/d/1Dd14rV-LRKpweIpemMZJj250S1Tg99l0/view?usp=sharing",
                        @click.stop
                      ) Terms and Conditions
                    div
                      span(class="mr-1") and
                      a(
                        href="https://drive.google.com/file/d/1YgEG1pBCy0iCq82q97LD3nULGjpGT0Jz/view?usp=sharing",
                        @click.stop,
                        target="_blank"
                      ) Privacy Policy
              div
                v-btn.mt-4(
                  block,
                  color="primary",
                  :disabled="!acceptTerms",
                  @click="select = 'our'"
                ) buy now

      //- v-col(md="6")
        v-card.d-flex.flex-column(
          color="deep-purple lighten-5",
          style="height: 100%"
        )
          v-card-title.text-center.justify-center.py-6(
            color="deep-purple lighten-1"
          )
            div
              h3 Hire an Immigration Advisor
              h3.mt-2 £750
          v-card-text(style="flex: 1")
            .d-flex.flex-column(style="height: 100%")
              ul.accept-list.body-1
                li Immigration advisor assistance
                li.mt-2 Tailored guidance
                li.mt-2 Friendly intuitive interface
                li.mt-2 Checklist of all documents
                li.mt-2 Case review by an immigration advisor
                li.mt-2 Cover letter
                li.mt-2 Online submission to Home Office
              div(style="flex: 1")
              span.pa-4 *Not including Home Office fees
              div
                v-btn(block, color="primary", @click="openDoc") Get Started

    PayDialog(v-if="select === 'our'", :open="open", @close="close")
    PayDialog(v-if="select === 'lawyer'", :open="open", @close="close")
</template>

<script>
import PayDialog from "./PayDialog";

export default {
  name: "pay-selection",

  components: {
    PayDialog,
  },

  props: ["open"],

  data: () => ({
    select: null,
    acceptTerms: false,
  }),

  methods: {
    close() {
      this.$emit("close");
      this.select = null;
    },

    openDoc() {
      this.$store.commit("openDoc", {
        type: "doc",
        url: process.env.VUE_APP_API_URL + "/document/" + 1,
      });
      this.select = "lawyer";
    },
  },
};
</script>

<style lang="sass" scoped>
.accept-list
  padding-left: 0
  margin: 0

  li
    padding: 3px 0px 3px 25px
    background: url(/check.png) no-repeat left center
    list-style: none
    margin: 0

.decline-list
  padding-left: 0
  margin: 0

  li
    background: url(/uncheck.png) no-repeat left center
    list-style: none
    margin: 0
    padding: 3px 0px 3px 25px
</style>